export default __webpack_public_path__ + "assets/Kalender_Ratenrechner_illu.svg";